import Navbar from "../components/navbar"
import { useState, useEffect } from "react"
import { FaBars } from "react-icons/fa"
import ProgressBar from "../components/progress-bar"
import { Button, message, Steps, theme, Upload, DatePicker } from 'antd';
import { Select, Space } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { HiSpeakerphone } from "react-icons/hi"
import { Link } from "react-router-dom";
import Footer from "../components/footer";
import { AiOutlineInfo } from "react-icons/ai";
import * as Yup from "yup"

const PersonalInfoPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [current, setCurrent] = useState(0);
    const { token } = theme.useToken();
    const [showCurrentAddress, setShowCurrentAddress] = useState(true)
    const [fName, setFName] = useState(null)
    const [lName, setLName] = useState(null)
    const [phoneNumber, setPhoneNumber] = useState(null)
    const [chat, setChat] = useState(null)
    const [email, setEmail] = useState(null)
    const [perAddress, setPerAddress] = useState(null)
    const [perAddress2, setPerAddress2] = useState(null)
    const [perCity, setPerCity] = useState(null)
    const [perState, setPerState] = useState(null)
    const [perZipCode, setPerZipCode] = useState(null)
    const [curAddress, setCurAddress] = useState(null)
    const [curCity, setCurCity] = useState(null)
    const [curState, setCurState] = useState(null)
    const [curZipCode, setCurZipCode] = useState(null)
    const [country, setCountry] = useState(null)
    const [futureEmployment, setFutureEmployment] = useState(false)
    const [isVaccinated, setIsVaccinated] = useState(false)
    const [isCovidBoosted, setIsCovidBoosted] = useState(false)

    const [professionOptions, setProfessionOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [professionSearch, setProfessionSearch] = useState(professionOptions[0])

    const [specialityOptions, setSpecialityOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [specialitySearch, setSpecialitySearch] = useState(specialityOptions[0])

    const [specialityTermOptions, setSpecialityTermOptions] = useState(["0 year", "1 years", "2 years", "3 years", "4 years", "5 years", "6 years", "7 years", "8 years", "9 years", "10 years", "11 years", "12 years", "13 years", "14 years", "15 years", "16 years", '17 years', "18 years", "19 years", "20 years", "21 years", "22 years", "23 years", "24 years", "25 years"])
    const [specialityTermSearch, setSpecialityTermSearch] = useState(specialityTermOptions[5])

    const [stateOptions, setStateOptions] = useState(["Sindh", "Punjab", "Balochistan", "KPK"])
    const [stateSearch, setStateSearch] = useState(stateOptions[0])

    const { Option } = Select;

    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const onDateChange = (date, dateString) => {
        console.log(date, dateString);
    };
    const onDateChange2 = (date, dateString) => {
        console.log(date, dateString);
    };

    const firstStepValidation = Yup.object().shape({
        email: Yup.string().required("Email is required").email(),
        phone: Yup.string().min(8, "Phone number should contain atleast 8 words").max(11, "Phone number can't exceed from 11").required(),
        lastName: Yup.string().required("Last name is required").min(3, "Last name should contain atleast 3 words"),
        firstName: Yup.string().required("First Name is required").min(3, "First name should contaion atleast 3 words"),
    })

    const perAddressValidation = Yup.object().shape({
        country: Yup.string().required().min(2),
        zipCode: Yup.number().required().min(2),
        state: Yup.string().required().min(2),
        city: Yup.string().required().min(2),
        address: Yup.string().required().min(2),
    })
    const curAddressValidation = Yup.object().shape({
        zipCode: Yup.number().required().min(2),
        state: Yup.string().required().min(2),
        city: Yup.string().required().min(2),
        address: Yup.string().required().min(2),
    })

    const next = () => {
        if (current === 0) {
            firstStepValidation.validate({ firstName: fName, lastName: lName, phone: phoneNumber, email: email }).then(() => {
                setCurrent(current + 1);
            }).catch((e) => {
                alert(e)
            })
        } else if (current === 1) {
            perAddressValidation.validate({
                address: perAddress,
                city: perCity,
                state: perState,
                zipCode: perZipCode,
                country: country
            }).then(() => {
                if (showCurrentAddress) {
                    console.log("Mai chal raha hun")
                    curAddressValidation.validate({
                        address: curAddress,
                        city: curCity,
                        state: curState,
                        zipCode: curZipCode,
                    }).then(() => {
                        setCurrent(current + 1)
                    }).catch((e) => {
                        alert(e)
                    })
                } else {
                    setCurrent(current + 1)
                }
            }).catch((e) => {
                alert(e)
            })
        } else {
            setCurrent(current + 1)
        }

    };
    const prev = () => {
        setCurrent(current - 1);
    };

    const props = {
        name: 'file',
        // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
    };

    const steps = [
        {
            title: 'Personal Information',
            content: <div className="w-full">
                <form className="p-4">
                    <div className="flex justify-between gap-x-3">
                        <div className="w-1/2 border-b border-black">
                            <label>
                                <span className="block text-gray-600 text-xs">First Name*</span>
                                <input value={fName} onChange={(e) => setFName(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                            </label>
                        </div>
                        <div className="w-1/2 border-b border-black">
                            <label>
                                <span className="block text-gray-600 text-xs">Last Name*</span>
                                <input value={lName} onChange={(e) => setLName(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                            </label>
                        </div>
                    </div>
                    <h1 className="my-2 font-semibold">Contact Info</h1>
                    <div className="flex justify-between gap-x-3">
                        <div className="w-1/2 border-b border-black">
                            <label>
                                <span className="block text-gray-600 text-xs">Phone*</span>
                                <input value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                            </label>
                        </div>
                        <div className="w-1/2 border-b border-black">
                            <label>
                                <span className="block text-gray-600 text-xs">When can you chat?</span>
                                <input value={chat} onChange={(e) => setChat(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                            </label>
                        </div>
                    </div>
                    <div className="flex justify-between gap-x-3 mt-4">
                        <div className="w-full border-b border-black">
                            <label>
                                <span className="block text-gray-600 text-xs">Email*</span>
                                <input value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                            </label>
                        </div>
                    </div>
                </form>
            </div>
        },
        {
            title: 'Address',
            content: <div className="w-full">
                <div>
                    <h1 className="font-semibold p-2">Permanent Address</h1>
                    <form className="p-4">
                        <div className="flex justify-between gap-x-3">
                            <div className="w-full border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">Address*</span>
                                    <input value={perAddress} onChange={(e) => setPerAddress(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                        </div>
                        <div className="flex justify-between gap-x-3 mt-2">
                            <div className="w-full border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">Address Line 2 (Optional)</span>
                                    <input value={perAddress2} onChange={(e) => setPerAddress2(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                        </div>
                        <div className="flex justify-between gap-x-3 mt-2">
                            <div className="w-1/2 border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">City*</span>
                                    <input value={perCity} onChange={(e) => setPerCity(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                            <div className="w-1/2 border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">State*</span>
                                    <input value={perState} onChange={(e) => setPerState(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                        </div>
                        <div className="flex justify-between gap-x-3 mt-2">
                            <div className="w-1/2 border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">Zip code*</span>
                                    <input value={perZipCode} onChange={(e) => setPerZipCode(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                            <div className="w-1/2 border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">Country*</span>
                                    <input value={country} onChange={(e) => setCountry(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                        </div>

                    </form>
                </div>
                <div>
                    <h1 className="font-semibold p-2">Current Address</h1>
                    <label className="flex items-center gap-x-2">
                        <input type="checkbox" className="focus:ring-0" onChange={() => setShowCurrentAddress(!showCurrentAddress)} />
                        <span>
                            Same as Permanent Address
                        </span>
                    </label>
                    {showCurrentAddress && <form className="p-4">
                        <div className="flex justify-between gap-x-3">
                            <div className="w-full border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">Address*</span>
                                    <input value={curAddress} onChange={(e) => setCurAddress(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                        </div>
                        <div className="flex justify-between gap-x-3 mt-2">
                            <div className="w-1/2 border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">City*</span>
                                    <input value={curCity} onChange={(e) => setCurCity(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                            <div className="w-1/2 border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">State*</span>
                                    <input value={curState} onChange={(e) => setCurState(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                        </div>
                        <div className="flex justify-between gap-x-3 mt-2">
                            <div className="w-full border-b border-black">
                                <label>
                                    <span className="block text-gray-600 text-xs">Zip code*</span>
                                    <input value={curZipCode} onChange={(e) => setCurZipCode(e.target.value)} type="text" className="w-full border-0 focus:outline-none focus:ring-0 bg-transparent" />
                                </label>
                            </div>
                        </div>

                    </form>}
                </div>
            </div>,
        },
        {
            title: 'Professional Details',
            content: <div className="w-full">
                <div className="p-4">
                    <h1 className="font-semibold text-xs">Profession*</h1>
                    <Select
                        mode="multiple"
                        maxLength={1}
                        className="w-full"
                        placeholder="select profession"
                        optionLabelProp="label"
                        value={professionSearch}
                        onChange={(e) => {
                            setProfessionSearch(e[e.length - 1])
                        }}
                    >

                        {
                            professionOptions?.map((val, i) => {
                                return (
                                    <Option key={i} value={val} label={val}>
                                        <Space>
                                            {val}
                                        </Space>
                                    </Option>
                                )
                            })
                        }
                    </Select>
                    <div className="flex items-center gap-x-2 mt-4 flex-col sm:flex-row gap-y-2">
                        <div className="w-full">
                            <h1 className="font-semibold text-xs mb-2">Speciality*</h1>
                            <Select
                                mode="multiple"
                                maxLength={1}
                                className="w-full"
                                placeholder="select one speciality"
                                optionLabelProp="label"
                                value={specialitySearch}
                                onChange={(e) => {
                                    setSpecialitySearch(e[e.length - 1])
                                }}
                            >

                                {
                                    specialityOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                        <div className="w-full">
                            <h1 className="font-semibold text-xs mb-2">Speciality Term*</h1>
                            <Select
                                mode="multiple"
                                maxLength={1}
                                className="w-full"
                                placeholder="select speciality term"
                                optionLabelProp="label"
                                value={specialityTermSearch}
                                onChange={(e) => {
                                    setSpecialityTermSearch(e[e.length - 1])
                                }}
                            >
                                {
                                    specialityTermOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                    </div>
                    <div className="mt-4">
                        <Upload {...props}>
                            <Button icon={<UploadOutlined />}>Click to Upload</Button>
                        </Upload>

                    </div>
                </div>
            </div>,
        },
        {
            title: 'Job Prefences',
            content: <div className="w-full">
                <div className="p-4">
                    <div className="flex w-full justify-between">
                        <div className="w-1/2">
                            <h1>Employment Type</h1>
                            <p className="text-xs text-gray-600">
                                Select all that apply
                            </p>
                        </div>
                        <div className="flex flex-col gap-y-1 w-1/2">
                            <label className="flex items-center gap-x-1 text-sm">
                                <input type="checkbox" name="" id="" className="checked:bg-gray-700 focus:ring-0" />
                                <span>Travel</span>
                            </label>
                            <label className="flex items-center gap-x-1 text-sm">
                                <input type="checkbox" name="" className="checked:bg-gray-700 focus:ring-0" id="" />
                                <span>Permanent</span>
                            </label>
                            <label className="flex items-center gap-x-1 text-sm">
                                <input type="checkbox" name="" className="checked:bg-gray-700 focus:ring-0" id="" />
                                <span>PerDiem</span>
                            </label>
                            <label className="flex items-center gap-x-1 text-sm">
                                <input type="checkbox" name="" className="checked:bg-gray-700 focus:ring-0" id="" />
                                <span>Locum Tenens</span>
                            </label>
                            <label className="flex items-center gap-x-1 text-sm">
                                <input type="checkbox" name="" className="checked:bg-gray-700 focus:ring-0" id="" />
                                <span>Interim Leadership</span>
                            </label>
                        </div>
                    </div>
                    <div className="flex w-full justify-between mt-6">
                        <div className="w-1/2">
                            <h1>Shift</h1>
                            <p className="text-xs text-gray-600">
                                Select all that apply
                            </p>
                        </div>
                        <div className="flex flex-col gap-y-1 w-1/2">
                            <label className="flex items-center gap-x-1 text-sm">
                                <input type="checkbox" name="" id="" className="checked:bg-gray-700 focus:ring-0" />
                                <span>Day</span>
                            </label>
                            <label className="flex items-center gap-x-1 text-sm">
                                <input type="checkbox" name="" className="checked:bg-gray-700 focus:ring-0" id="" />
                                <span>Mid</span>
                            </label>
                            <label className="flex items-center gap-x-1 text-sm">
                                <input type="checkbox" name="" className="checked:bg-gray-700 focus:ring-0" id="" />
                                <span>Night</span>
                            </label>
                        </div>
                    </div>
                    <div className="mt-6 flex flex-col w-fit">
                        <span className="text-sm text-gray-600">
                            Available start date
                        </span>
                        <DatePicker placeholder="MM/DD/YYYY" onChange={onDateChange} className="border-0 border-b border-black bg-transparent rounded-none hover:ring-0" />
                    </div>

                    <div className="mt-6">
                        <h1 className="text-sm mb-2">My Top Places To Work</h1>
                        <Select
                            mode="multiple"
                            className="w-full"
                            placeholder="Add a state"
                            optionLabelProp="label"
                            value={stateSearch}
                            onChange={(e) => {
                                setStateSearch(e)
                            }}
                        >
                            {
                                stateOptions?.map((val, i) => {
                                    return (
                                        <Option key={i} value={val} label={val}>
                                            <Space>
                                                {val}
                                            </Space>
                                        </Option>
                                    )
                                })
                            }
                        </Select>
                    </div>
                    <div className="flex w-full items-center mt-6 gap-x-2 bg-[#ffedac] p-2">
                        <div>
                            <HiSpeakerphone />
                        </div>
                        <p>
                            Want more licenses? Aya can help! Talk to your recruiter for more info.
                        </p>
                    </div>
                </div>
            </div>,
        },
        {
            title: 'Submittal Info',
            content: <div className="w-full">
                <div className="p-4">
                    <h1>Aya collects and uses this info consistent with its Privacy Policy</h1>
                    <h2 className="font-semibold mt-2 mb-4">
                        Legal Name
                    </h2>
                    <div className="flex">
                        <div>
                            Date of Birth <span className="text-red-600">*</span>
                        </div>
                        <div className="flex gap-x-2">
                            <DatePicker placeholder="MM/DD/YYYY" onChange={onDateChange2} className="border-0 border-b border-black bg-transparent rounded-none hover:ring-0" />
                            <div class="relative z-0">
                                <input type="number" id="floating_ssn" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" />
                                <label for="floating_ssn" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">SSN*</label>
                            </div>
                        </div>
                    </div>
                    <div className="mt-6">
                        <p className="font-semibold text-xs" onClick={() => console.log(futureEmployment)}>
                            Will you now, or in the future for continued employment with Employer, require Employer to sponsor you for U.S. employment authorization, work visa/status, employer-based immigration benefit(s), such as an H-1B, E-3, TN, PERM, I-140, I-485 Supplement J, “green card”, etc.? <span className="text-red-500">*</span>
                        </p>
                        <div className="flex gap-x-2 items-center mt-2">
                            <label className="flex items-center gap-x-1">
                                <input type="radio" className="checked:ring-0" checked={futureEmployment === false} name="future-employment" onChange={() => setFutureEmployment(false)} />
                                <span>No</span>
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="radio" className="checked:ring-0" checked={futureEmployment === true} name="future-employment" onChange={() => setFutureEmployment(true)} />
                                <span>Yes</span>
                            </label>
                        </div>
                    </div>
                    <div className="mt-6">
                        <p className="font-semibold text-xs" onClick={() => console.log(isVaccinated, "vaccine")}>
                            Are you fully vaccinated against COVID-19 as defined by the CDC?<span className="text-red-500">*</span>
                        </p>
                        <div className="flex gap-x-2 items-center mt-2">
                            <label className="flex items-center gap-x-1">
                                <input type="radio" className="checked:ring-0" checked={isVaccinated === false} name="vaccinated" onChange={() => setIsVaccinated(false)} />
                                <span>No</span>
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="radio" className="checked:ring-0" checked={isVaccinated === true} name="vaccinated" onChange={() => setIsVaccinated(true)} />
                                <span>Yes</span>
                            </label>
                        </div>
                    </div>
                    {isVaccinated && <div className="mt-6">
                        <p className="font-semibold text-xs" onClick={() => console.log(isCovidBoosted)}>
                            Some facilities or state and local laws will require that you have received the COVID-19 booster to work at the facility. Have you received the COVID-19 booster?<span className="text-red-500">*</span>
                        </p>
                        <div className="flex gap-x-2 items-center mt-2">
                            <label className="flex items-center gap-x-1">
                                <input type="radio" className="checked:ring-0" checked={isCovidBoosted === false} value={false} name="covid_boosted" onChange={(e) => setIsCovidBoosted(false)} />
                                <span>No</span>
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="radio" checked={isCovidBoosted === true} className="checked:ring-0" name="covid_boosted" value={true} onChange={(e) => setIsCovidBoosted(true)} />
                                <span>Yes</span>
                            </label>
                        </div>
                    </div>}
                </div>
            </div>,
        },
    ];
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        // lineHeight: '260px',
        // textAlign: 'center',
        // color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        // borderRadius: token.borderRadiusLG,
        // border: `1px dashed ${token.colorBorder}`,
        // marginTop: 16,
    };

    useEffect(() => {
        let myArr = stateOptions.slice(0, 2)
        setStateSearch(myArr)
    }, [])

    return (
        <Navbar active={"My jobs"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-bold">Personal Info</h1>
            </div>
            <div className="relative top-14 pb-28">
                <div className="px-3 lg:px-8">
                    <div className="mt-5">
                        <h1>Application Progress</h1>
                        <div className="mt-2">
                            <ProgressBar active={"personal info"} />
                        </div>
                    </div>

                    <div className="p-2 mt-4 rounded-lg" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                        <Steps current={current} items={items} />
                        <div style={contentStyle}>{steps[current].content}</div>
                        <div
                            style={{
                                marginTop: 24,
                            }}
                        >
                            {current < steps.length - 1 && (
                                <Button onClick={() => next()}>
                                    Next
                                </Button>
                            )}
                            {current === steps.length - 1 && (
                                <Link to={"/work-history"} className="bg-blue-500 p-1 rounded text-white hover:!text-white">
                                    Next
                                </Link>
                            )}
                            {current > 0 && (
                                <Button
                                    style={{
                                        margin: '0 8px',
                                    }}
                                    onClick={() => prev()}
                                >
                                    Previous
                                </Button>
                            )}
                        </div>
                    </div>

                </div>
            </div>
            <div className="fixed bottom-0 w-full">
                <Footer></Footer>
            </div>
        </Navbar>
    )
}

export default PersonalInfoPage